import React from "react";
import SpreadsContent from "../components/spreads/spreads-content";

const Spreads = () => {
  return <SpreadsContent />;
};

export default Spreads;
